import { useEffect, useState } from "react";
import { drawerClasses } from "@mui/material";

/**
 * True when a temporary MUI Drawer is portaled as a direct child of `document.body`.
 * Does not cover `disablePortal` or docked/persistent drawers (no subtree walk).
 * Closed `keepMounted` roots (`aria-hidden="true"`) do not count as open.
 */
const isOpenBodyDrawer = (el: Element): boolean =>
  el.classList.contains(drawerClasses.root) &&
  el.getAttribute("aria-hidden") !== "true";

const hasOpenBodyDrawer = (): boolean => {
  for (const child of document.body.children) {
    if (isOpenBodyDrawer(child)) return true;
  }
  return false;
};

export const useBodyMuiDrawerOpen = (): boolean => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const sync = () => {
      const next = hasOpenBodyDrawer();
      setOpen((prev) => (prev === next ? prev : next));
    };

    sync();

    const observer = new MutationObserver(sync);
    observer.observe(document.body, { childList: true });

    return () => observer.disconnect();
  }, []);

  return open;
};
